import { getProperties } from 'aws-amplify/storage';
import { getFullBucketName, S3Bucket } from '../config/constants';
import { useEffect, useState } from 'react';

type UseProps = {
  bucket: S3Bucket;
  path: string | undefined | null;
};

// The stored object's Content-Type, for files whose key carries no extension.
// `null` once the lookup fails or the object has no type.
export const useAmplifyFileContentType = ({ path, bucket }: UseProps) => {
  const key = bucket + path;

  const [data, setData] = useState<{
    key: string;
    contentType: string | null;
  }>();

  useEffect(() => {
    if (data?.key === key || !path) return;

    // A reply for a previous key must not overwrite the current one.
    let cancelled = false;
    getProperties({
      path,
      options: { bucket: getFullBucketName(bucket) }
    })
      .then(({ contentType }) => {
        if (!cancelled) setData({ key, contentType: contentType ?? null });
      })
      .catch(() => {
        if (!cancelled) setData({ key, contentType: null });
      });

    return () => {
      cancelled = true;
    };
  }, [key]);

  return {
    contentType: key === data?.key ? data.contentType : undefined
  };
};
